import type { EvaluationScope } from '@/features/eventEvaluations/types/EvaluationScope';
import type { EvaluationScopeConfig } from '@/features/eventEvaluations/types/EvaluationScopeConfig';

/** The two readers of the analysis (tor.md §6.11): the administration, over every event, and an
 * organiser, over the events they authored. */
export const EVALUATION_SCOPE = {
  admin: 'admin',
  mine: 'mine',
} as const;

/**
 * What differs between the two screens, and nothing else: the endpoints, the words at the top and
 * the organiser filter and grouping. An organiser's own events share one organiser, so offering to
 * split them by organiser would be a list of one — and the mine endpoints ignore the filter anyway.
 */
export const EVALUATION_SCOPES: Record<EvaluationScope, EvaluationScopeConfig> = {
  admin: {
    analysisPath: '/api/v1/admin/event-evaluations/analysis',
    exportPath: '/api/v1/admin/event-evaluations/export',
    showsOrganizers: true,
    heading: 'adminHeading',
    lead: 'adminLead',
    back: null,
  },
  mine: {
    analysisPath: '/api/v1/events/mine/evaluation-analysis',
    exportPath: '/api/v1/events/mine/evaluation-analysis/export',
    showsOrganizers: false,
    heading: 'mineHeading',
    lead: 'mineLead',
    back: { to: '/app/evenimentele-mele', label: 'backToMyEvents' },
  },
};
